import { InsightNotification, LiveUpdateNotification, TrackerNotification, TrackerNotificationData, NotificationShowMode } from 'interfaces/notifications'
import { TRACKER_LIMIT_TYPE } from 'constants/moneyflow'
import { generate } from 'randomstring'
import { Insight } from 'interfaces/insights'
import { LiveUpdateInfoByStatus } from 'interfaces/linkage'
import { isWarningInsight } from 'helpers/insightHelpers'

export const getInsightNotification = (insight: Insight): InsightNotification => ({
  id: `insight_${ insight.id }`,
  text: insight.text,
  type: 'insight',
  showMode: 'regular',
  icon: isWarningInsight(insight) ? 'warning' : undefined,
  insight,
})

export const createTrackerNotification = (creationData: TrackerNotificationData): TrackerNotification => {
  const { id, type, limit, category, isNew } = creationData
  const limitHighTextAppend = limit > 100000
    ? ` Please note: a very high ${ TRACKER_LIMIT_TYPE[type] } may make your charts difficult to interpret.`
    : ''

  const textIfTrackerIsNew = `Your ${ category.value } tracker has been added to your dashboard.${ limitHighTextAppend }`
  const textIfTrackerIsNotNew = `Your ${ category.value } tracker limit is now $${ limit }.`
  return {
    id: `tracker-creation_${ id }_${ generate() }`,
    type: 'tracker',
    text: isNew ? textIfTrackerIsNew : textIfTrackerIsNotNew,
    showMode: 'fresh',
    creationData,
  }
}

// TODO: test
export const createLiveUpdateNotification = (
  info: LiveUpdateInfoByStatus<'started' | 'buffered'>,
  prevNotification?: LiveUpdateNotification
): LiveUpdateNotification | null => {

  if (info.status === 'started') {
    const text = info.total_count === 1
      ? `Fetching the latest data for your account…`
      : `Fetching the latest data for ${ info.total_count } of your accounts…`

    let showMode: NotificationShowMode = 'fresh'
    let prevShowMode: NotificationShowMode | undefined

    // If notification is updating, showMode and prevShowMode should not be changed
    if (prevNotification) {
      showMode = prevNotification.showMode
      prevShowMode = prevNotification.prevShowMode
    }

    return {
      id: 'live-update',
      type: 'live-update',
      text,
      icon: 'spinner-light',
      showMode,
      prevShowMode,
      info,
    }
  }

  // Buffered notification should be removed instead update
  if (prevNotification && prevNotification.showMode === 'pinned') {
    return null
  }

  // Notification becomes buffered
  return {
    id: 'live-update',
    type: 'live-update',
    icon: 'success',
    text: `New data is available for ${ info.buffered_count } of your accounts. Click ‘Update Now’ to see the latest numbers.`,
    showMode: 'pinned',
    prevShowMode: prevNotification ? prevNotification.showMode : undefined,
    info,
  }
}
